export default "__VITE_ASSET__C6iL2U26__"